import { Component, OnInit } from '@angular/core';
import { NgwWowService } from 'ngx-wow';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  slideConfig = {
    "slidesToShow" : 1,
    "slidesToScroll" : 1,
    "dots" : true,
    "infinite" : false,
    "vertical" : true,
    // "autoRotate" : true,
    // "autoRotateAfter" : 5000,
    "autoplay" : true,
    "autoplaySpeed" : 3500
  };

  constructor(private wowService: NgwWowService) { }

  ngOnInit(): void {
    this.wowService.init();
  }

}
